/* eslint-disable no-new */
import { KeenSliderNavigation } from "./keen-slider-navigation-plugin";
import KeenSlider from "keen-slider";

/**
 * Initializes a KeenSlider on all elements with the `[js-slider]` attribute.
 *
 */
export const buildSlider = () => {
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[js-slider]").forEach((slider) => {
      new KeenSlider(slider, {}, [
        KeenSliderNavigation({ arrows: false, dots: false }),
      ]);
    });
  });
};
